/* Blowhammer home 2026, first screen (B-HOME 12/10/2026). Phone only: one button swaps the tavola
   and the real photo. The real photo is lazy and hidden until then, so it downloads on the first tap. */
(function () {
  document.querySelectorAll('[data-na-hero]').forEach(function (sezione) {
    var bottone = sezione.querySelector('.na-hero__scambia');
    if (!bottone) return;
    bottone.addEventListener('click', function () {
      var vero = sezione.getAttribute('data-vista') !== 'vero';
      sezione.setAttribute('data-vista', vero ? 'vero' : 'mondo'); // E-PULIZIA 16/10/2026 (push-27, P10), la vista della tavola si chiama «mondo»
      bottone.textContent = vero ? bottone.dataset.testoGen : bottone.dataset.testoVero;
    });
  });
})();
